(function(){
  'use strict';
  
  // DOM 元素
  var WRAPPER = document.getElementById('spec-bar-wrapper');
  var ROOT = document.getElementById('spec-bar');
  if (!WRAPPER || !ROOT) return;

  var list = ROOT.querySelector('.sb-list');
  var links = Array.from(ROOT.querySelectorAll('.sb-link'));
  
  // 从 data 属性获取配置
  var HEADER_OFFSET_DESKTOP = Number(WRAPPER.dataset.headerDesktop) || 80;
  var HEADER_OFFSET_MOBILE = Number(WRAPPER.dataset.headerMobile) || 60;
  var STICK_BELOW_HEADER = WRAPPER.dataset.stickBelowHeader !== 'false';
  
  var DEBOUNCE_DELAY = 100;
  var THROTTLE_DELAY = 16;
  
  var state = {
    isStuck: false,
    currentActive: null,
    targetCache: new Map(),
    barHeight: 0
  };
  
  function getCurrentHeaderOffset() {
    return window.innerWidth >= 1024 ? HEADER_OFFSET_DESKTOP : HEADER_OFFSET_MOBILE;
  }
  
  function debounce(func, wait) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() { func.apply(context, args); }, wait);
    };
  }
  
  function throttle(func, limit) {
    var inThrottle;
    return function() {
      var args = arguments;
      var context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(function() { inThrottle = false; }, limit);
      }
    };
  }
  
  function slugify(text) {
    return (text || '').toLowerCase().trim().replace(/[\s\/]+/g, '-').replace(/[^a-z0-9\-]/g, '').replace(/\-+/g, '-');
  }
  
  function buildTargetCache() {
    var selectors = ['main h2', 'main h3', 'section h2', 'section h3', 'h2', 'h3'];
    state.targetCache.clear();
    selectors.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(el) {
        var text = (el.textContent || '').trim();
        if (text) {
          var key = text.toLowerCase();
          if (!state.targetCache.has(key)) state.targetCache.set(key, el);
        }
      });
    });
  }
  
  function findTargetEl(label) {
    var key = label.toLowerCase();
    var target = state.targetCache.get(key);
    if (!target) {
      for (var [cachedKey, el] of state.targetCache) {
        if (cachedKey.includes(key) || key.includes(cachedKey)) {
          target = el;
          break;
        }
      }
    }
    return target ? (target.closest('section') || target) : null;
  }
  
  function scrollToWithOffset(el) {
    if (!el) return;
    var rect = el.getBoundingClientRect();
    var absoluteY = window.pageYOffset + rect.top;
    var currentHeaderOffset = getCurrentHeaderOffset();
    var navBarHeight = state.barHeight;
    var totalOffset = currentHeaderOffset + navBarHeight;
    var y = absoluteY - totalOffset;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }
  
  function setActive(link) {
    if (state.currentActive === link) return;
    links.forEach(function(l) { l.setAttribute('aria-selected', 'false'); });
    if (link) {
      link.setAttribute('aria-selected', 'true');
      state.currentActive = link;
      if (window.innerWidth <= 1023) {
        var scrollLeft = link.offsetLeft - (list.offsetWidth - link.offsetWidth) / 2;
        list.scrollTo({ left: scrollLeft, behavior: 'smooth' });
      }
    }
  }
  
  function updateFades() {
    if (window.innerWidth > 1023) return;
    var maxScroll = list.scrollWidth - list.clientWidth;
    ROOT.style.setProperty('--fade-left', list.scrollLeft > 2 ? '1' : '0');
    ROOT.style.setProperty('--fade-right', (maxScroll - list.scrollLeft) > 2 ? '1' : '0');
  }
  
  function measureBar() {
    var rect = ROOT.getBoundingClientRect();
    state.barHeight = rect.height;
  }

  // 检测 sticky 状态
  function setupStickyObserver() {
    if (!STICK_BELOW_HEADER) return;
    
    // 创建一个哨兵元素来检测 sticky 状态
    var sentinel = document.createElement('div');
    sentinel.className = 'sticky-sentinel';
    sentinel.style.position = 'absolute';
    sentinel.style.top = '-1px';
    sentinel.style.left = '0';
    sentinel.style.right = '0';
    sentinel.style.height = '1px';
    sentinel.style.pointerEvents = 'none';
    sentinel.style.visibility = 'hidden';
    
    // 将哨兵元素插入到 wrapper 之前
    WRAPPER.parentElement.insertBefore(sentinel, WRAPPER);
    
    var observer = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          // 当哨兵元素不可见时，说明导航栏处于 sticky 状态
          var isStuck = !entry.isIntersecting;
          if (isStuck !== state.isStuck) {
            state.isStuck = isStuck;
            ROOT.classList.toggle('is-stuck', isStuck);
          }
        });
      },
      { 
        // 考虑 header 的高度
        rootMargin: `-${getCurrentHeaderOffset()}px 0px 0px 0px`,
        threshold: [0, 1]
      }
    );
    
    observer.observe(sentinel);
    return { observer: observer, sentinel: sentinel };
  }
  
  function initializeLinks() {
    buildTargetCache();
    var idToLinkMap = new Map();
    links.forEach(function(link) {
      var label = link.dataset.label || link.textContent.trim();
      var target = findTargetEl(label);
      if (target) {
        if (!target.id) target.id = 'section-' + slugify(label);
        link.dataset.targetId = target.id;
        idToLinkMap.set(target.id, link);
      } else {
        link.classList.add('is-disabled');
        link.setAttribute('aria-disabled', 'true');
      }
    });
    return idToLinkMap;
  }
  
  function handleLinkClick(e) {
    var targetId = e.currentTarget.dataset.targetId;
    if (targetId) {
      e.preventDefault();
      var targetEl = document.getElementById(targetId);
      scrollToWithOffset(targetEl);
      // Temporarily set active, observer will correct if needed
      setActive(e.currentTarget);
    }
  }
  
  function setupIntersectionObserver(idToLinkMap) {
    var currentHeaderOffset = getCurrentHeaderOffset();
    var navBarHeight = ROOT.offsetHeight || 50;
    var totalOffset = currentHeaderOffset + navBarHeight;
    var observerOptions = { rootMargin: `-${totalOffset}px 0px -60% 0px` };
    
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var link = idToLinkMap.get(entry.target.id);
          if (link) setActive(link);
        }
      });
    }, observerOptions);
    
    idToLinkMap.forEach(function(link, id) {
      var el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return observer;
  }
  
  function initialize() {
    var idToLinkMap = initializeLinks();
    var observer = setupIntersectionObserver(idToLinkMap);
    var stickySetup = setupStickyObserver();
    
    links.forEach(function(link) {
      link.addEventListener('click', handleLinkClick);
    });

    list.addEventListener('scroll', throttle(updateFades, THROTTLE_DELAY), { passive: true });

    var debouncedResize = debounce(function() {
      measureBar();
      observer.disconnect();
      observer = setupIntersectionObserver(idToLinkMap);
      
      // 重新设置 sticky observer
      if (stickyObserver) {
        stickyObserver.disconnect();
        stickyObserver = new IntersectionObserver(
          function(entries) {
            entries.forEach(function(entry) {
              var isStuck = entry.intersectionRatio < 1;
              if (isStuck !== state.isStuck) {
                state.isStuck = isStuck;
                ROOT.classList.toggle('is-stuck', isStuck);
              }
            });
          },
          { 
            threshold: [1],
            rootMargin: `-${getCurrentHeaderOffset() + 1}px 0px 0px 0px`
          }
        );
        stickyObserver.observe(ROOT);
      }
    }, DEBOUNCE_DELAY);
    
    window.addEventListener('resize', debouncedResize);
    
    // Initial setup after a short delay to ensure layout is stable
    setTimeout(function() {
      measureBar();
      updateFades();
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();